// Module
var code = "<script>let $ctrl</script> <a class=\"atom-logo-main\" themable ui-sref=\"dashboard\"> <div themable class=\"atom-logo-main__wrapper\" id=\"logo-main\"> <img themable ng-src=\"{{ $ctrl.logoPath }}\" alt=\"logo\"> </div> </a> ";
// Exports
module.exports = code;